import React from 'react';
/* External */
import PropTypes from 'prop-types';

/* Ott-common */
import Icon from '@dtvgo/icon';
// import { useIntl } from 'react-intl';

/* Components */
import MenuButton from '../MenuButton/MenuButton';

/* Styles */
import './MoreChannelsButton.scss';

function MoreChannelsButton({ openEpgHandler }) {
  // const { formatMessage } = useIntl();

  return (
    <MenuButton
      onClick={() => openEpgHandler({ option: 'epg_zapping_option_two' })}
      showOnClick={false}
      buttonContent={(
        <div className="dtv-more-channels-content-button">
          <Icon name="monitor" />
          {/* <div className="dtv-more-channels-tooltip">
            {formatMessage({ id: 'player.moreChannels' })}
          </div> */}
        </div>
        )}
      id="btn-open-epg-zapping-option-2"
      className="dtv-common-c-more-channels-button"
    />
  );
}

MoreChannelsButton.defaultProps = {
  openEpgHandler: PropTypes.func,
};

export default MoreChannelsButton;
